module.exports = __webpack_public_path__ + "static/img/zizhi1_03.18cc7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/intelligence/zizhi1_03.jpg
// module id = 6w8E
// module chunks = 0